var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisabledEmailSelector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 61,
    viewBox: "0 0 75 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H71C73.2091 0 75 1.79086 75 4V57C75 59.2091 73.2091 61 71 61H4C1.79086 61 0 59.2091 0 57V4Z",
    fill: "#D7D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.107 17.4286H23.9641C22.1668 17.4286 20.7126 18.654 20.7126 20.1518L20.6963 36.4911C20.6963 37.9889 22.1668 39.2143 23.9641 39.2143H50.107C51.9043 39.2143 53.3749 37.9889 53.3749 36.4911V20.1518C53.3749 18.654 51.9043 17.4286 50.107 17.4286ZM50.107 22.875L37.0356 29.6831L23.9641 22.875V20.1518L37.0356 26.9598L50.107 20.1518V22.875Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledEmailSelector);
export default __webpack_public_path__ + "static/media/disabled-email-selector.2bb4ada8a973b9f662222b9a0dfa0432.svg";
export { ForwardRef as ReactComponent };